import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import printerimg from "../../../../assets/print.png";
import { usePageState } from "../../../../Hook/usePageState";
import { useItemcodeserialMutation } from "../../../../store/api/serialnoapi";
import { useCompanyserialMutation } from "../../../../store/api/serialnoapi";
import { useWorkOrderserialMutation } from "../../../../store/api/serialnoapi";
import { usePostCreateSerialNoMutation } from "../../../../store/api/serialnoapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";

const PurchaseSerialList = () => {
  const navigate = useNavigate();

  // State for API data
  const [itemCodeList, setItemCodeList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [workOrderList, setWorkOrderList] = useState([]);

  // Separate state for API response values
  const [apiResponse, setApiResponse] = useState({
    poResponse: "",
    error: "",
    ptype: "Error",
    showError: false
  });

  // Separate state for field errors
  const [fieldErrors, setFieldErrors] = useState({
    serialNo: false,
    itemCode: false,
    warrantyExpiryDate: false,
    amcExpiryDate: false,
    company: false,
    workOrder: false
  });

  const pageStateDefault = {
    tab: 1,
    finalstep: false,
    serialNo: "",
    itemCode: "",
    warrantyExpiryDate: "",
    amcExpiryDate: "",
    company: "",
    workOrder: "",
    parentItemGroup: "",
    unicommerceProductCategoryCode: "",
    isGroup: "",

  };

  const [pageState, setPageState] = usePageState(`Purchase Serial List`, pageStateDefault);

  const handleInputChange1 = (f, v) => {
    setPageState({ ...pageState, [f]: v });

  };

  const {
    tab, finalstep, serialNo, itemCode, warrantyExpiryDate, amcExpiryDate,
    company, workOrder
  } = pageState;

  const { poResponse, error, ptype, showError } = apiResponse;

  console.log(pageState, "inital values");

  const [ItemcodeserialApi] = useItemcodeserialMutation();
  const [CompanyserialApi] = useCompanyserialMutation();
  const [WorkOrderserialApi] = useWorkOrderserialMutation();
  const [CreateSerialNo] = usePostCreateSerialNoMutation();

  const updateNestedState = (key, nestedKey, value) => {
    setPageState(prev => ({
      ...prev,
      [key]: {
        ...prev[key],
        [nestedKey]: value
      }
    }));
  };

  const updateApiResponse = (updates) => {
    setApiResponse(prev => ({
      ...prev,
      ...updates
    }));
  };

  // Helper function to update field errors
  const updateFieldErrors = (updates) => {
    setFieldErrors(prev => ({
      ...prev,
      ...updates
    }));
  };

  // Helper function to reset field errors
  const resetFieldErrors = () => {
    setFieldErrors({
      serialNo: false,
      itemCode: false,
      warrantyExpiryDate: false,
      amcExpiryDate: false,
      company: false,
      workOrder: false
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [itemCodeResponse, companyResponse, workOrderResponse] = await Promise.all([
          ItemcodeserialApi(),
          CompanyserialApi(),
          WorkOrderserialApi()
        ]);

        // Store API responses in separate state
        setItemCodeList(itemCodeResponse.data?.data || []);
        setCompanyList(companyResponse.data?.data || []);
        setWorkOrderList(workOrderResponse.data?.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [ItemcodeserialApi, CompanyserialApi, WorkOrderserialApi]);

  console.log(itemCodeList, "itemCodeList");

  const handleSubmit = async () => {
    // Reset field errors
    resetFieldErrors();

    // Check for errors
    const newErrors = {
      serialNo: !serialNo,
      itemCode: !itemCode,
      warrantyExpiryDate: !warrantyExpiryDate,
      amcExpiryDate: !amcExpiryDate,
      company: !company,
      workOrder: !workOrder
    };

    setFieldErrors(newErrors);

    const errorMessages = {
      serialNo: "Please Fill Serial No.",
      itemCode: "Please Select Item Code.",
      warrantyExpiryDate: "Please Select Warranty Expiry Date.",
      amcExpiryDate: "Please Select Amc Expiry Date.",
      company: "Please Select Company.",
      workOrder: "Please Select Work Order."
    };

    for (const [field, message] of Object.entries(errorMessages)) {
      if (newErrors[field]) {
        updateApiResponse({
          ptype: "Error",
          error: message,
          showError: true
        });
        return;
      }
    }

    const payload = {
      serial_no: serialNo,
      item_code: itemCode,
      warranty_expiry_date: warrantyExpiryDate,
      amc_expiry_date: amcExpiryDate,
      company: company,
      work_order: workOrder,
    };

    console.log("create serial number payload:", payload);

    try {
      const response = await CreateSerialNo(payload);
      setPageState(pageStateDefault)

      const stripHTML = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      };

      if (response.error) {
        let errorMessage = "Creation failed";

        if (response.error.data && response.error.data._server_messages) {
          try {
            const serverMessages = JSON.parse(response.error.data._server_messages);
            if (Array.isArray(serverMessages) && serverMessages.length > 0) {
              const parsedMessage = JSON.parse(serverMessages[0]);
              errorMessage = parsedMessage.message || errorMessage;
            }
          } catch (e) {
            console.warn("Failed to parse _server_messages", e);
          }
        } else {
          errorMessage =
            response.error.data?.message ||
            response.error.data?.exception ||
            errorMessage;
        }

        errorMessage = stripHTML(errorMessage);

        updateApiResponse({
          ptype: "Error",
          error: errorMessage,
          showError: true
        });
        return;
      }

      updateApiResponse({
        poResponse: response.data,
        error: "Serial No created successfully!",
        ptype: "Success",
        showError: true
      });

      setTimeout(() => {
        navigate("/master/serialno/serialno-list");
      }, 2000);
    } catch (err) {
      updateApiResponse({
        error: err?.data?.message || "Unexpected error occurred.",
        ptype: "Error",
        showError: true
      });
    }
  };

  return (
    <FormLayout
      title="New Serial No"
      breadcrumbs={[
        { label: "Serial No" },
        { label: "Serial No List", url: "/master/serialno/serialno-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => { }}
            to="/"
            state={poResponse?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            Save
          </Button>
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => setPageState({ tab: 1 })}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: "12px" }}>
              <span style={{ position: "relative", top: "-1px" }}>
                <GetIcon iconName="CgAttachment" size={12} />
              </span>
              <span className=" fw-semibold" style={{ color: "#391F84" }}>
                Attachments
              </span>
            </div>
          </div>
        </div>

        <div className="mt-2" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}>
          <div className="mt-2 py-2" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}>
            <div className="row d-flex justify-content-between">
              <div className="col-12">
                <div className="sidebarbox m-0 px-4 py-2" style={{ height: '100vh' }}>
                  <Tab1
                    pageState={pageState}
                    handleChange={handleInputChange1}
                    itemCodeList={itemCodeList}
                    fieldErrors={fieldErrors}
                  />
                  <Tab2
                    pageState={pageState}
                    handleChange={handleInputChange1}
                    itemCodeList={itemCodeList}
                    fieldErrors={fieldErrors}
                  />
                  <Tab3
                    workOrderList={workOrderList}
                    pageState={pageState}
                    setPageState={setPageState}
                    fieldErrors={fieldErrors}
                    companyList={companyList}
                    
                    handleChange={handleInputChange1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => updateApiResponse({ showError: false })}
      />
    </FormLayout>
  );
};

export default PurchaseSerialList;